import React from "react";
import styled from "styled-components";
import { HiMagnifyingGlass } from "react-icons/hi2";

const SearchInputWrapper = styled.div<{extended: boolean}>`
  position: relative;
  width: 100%;

           @media (max-width: 768px) {
    border-radius: 41px;
    max-width: 60%;
  }

  ${({ extended }) => (extended ? "width: 100%; box-sizing: border-box; " : "max-width: 306px;")}

  display: flex; /* теперь гибкий контейнер */
  align-items: center;

`;

const IconWrapper = styled.div`
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: rgba(91, 91, 91, 1);
  display: flex;
  align-items: center;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px 14px 10px 34px; /* оставляем padding для иконки */
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  border-radius: 6px;
  border: 1px solid rgba(31, 31, 31, 1);
  background-color: var(--primary-color);
  color: var(--text-color);
  font-family: "Onest", sans-serif;

         @media (max-width: 768px) {
    border-radius: 41px;
    border: 0;
    

  }

  &::placeholder {
    color: rgba(91, 91, 91, 1);
  }

  &:focus {
    outline: none;
    border-color: var(--text-active-color);
  }
`;

type SearchInputProps = {
  value: string;
  onChange: (val: string) => void;
  placeholder?: string;
  style?: React.CSSProperties; // для возможности flex:1 снаружи
};

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder,
  style,
  extended=false,
}) => {
  return (
    <SearchInputWrapper extended={extended} style={style}>
      <IconWrapper>
        <HiMagnifyingGlass size={16} />
      </IconWrapper>
      <Input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder || "Поиск..."}
      />
    </SearchInputWrapper>
  );
};
